import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useLink } from '../../hooks/useLink.js';
import { useLocation } from '../../hooks/useLocation.js';
import { useRegions } from '../../hooks/useRegions.js';
import { groupBy } from '../../utils/groupBy.js';
import { jaroWinklerDistance } from '../../utils/jaroWinklerDistance.js';
import { Dialog } from '../DialogManager/Dialog.js';
import { useDialogManager } from '../DialogManager/useDialogManager.js';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper.js';
import { Paragraph } from '../Paragraph/Paragraph.js';
import { Text } from '../Text/Text.js';
import { renderForeignOffices } from './renderForeignOffices.js';
import { renderRegion } from './renderRegion.js';
import { renderRegionGroup } from './renderRegionGroup.js';
import { SearchBar } from './SearchBar.js';
const SEARCH_TERM_MIN_LENGTH = 3;
export const LocationDialog = JSX(({ foreignOffices, branches }) => {
    const [currentLocation, selectCurrentLocation] = useLocation(branches?.default);
    const link = useLink();
    const { href } = link({ href: `/branches/${currentLocation.slug}` });
    const [query, setQuery] = useState('');
    const regions = cleanUpRegions(useRegions()).sort((a, b) => a.name.localeCompare(b.name));
    const regionsGroupByLetter = groupBy(regions, regionFirstLetter);
    const { close } = useDialogManager();
    const handleChangeLocation = useCallback((region) => {
        selectCurrentLocation(region);
        close();
    }, []);
    return (_jsxs(Dialog, { className: "pb-20", head: _jsxs("div", { children: [_jsx(Text, { size: "text-h4", color: "text-primary-text", children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0438\u043B\u0438\u0430\u043B" }), currentLocation ? (_jsx("div", { className: "mb-s", children: _jsxs(Paragraph, { size: "text-l", color: "text-primary-text", children: ["\u0421\u0435\u0439\u0447\u0430\u0441 \u0432\u044B\u0431\u0440\u0430\u043D:", _jsx(LinkWrapper, { href: href, className: "inline mx-2xs text-primary-main", children: currentLocation.name })] }) })) : null, _jsx(SearchBar, { onSearch: setQuery, searchTerm: query })] }), children: [query && query.length >= SEARCH_TERM_MIN_LENGTH ? (_jsx("div", { children: regions
                    .filter(({ name }) => name && jaroWinklerDistance(name.toLowerCase())(query.toLowerCase()) >= 0.8)
                    .map(renderRegion(branches?.dataSelect, handleChangeLocation)) })) : (_jsx("div", { className: "columns-1 sm:columns-3 md:columns-4 lg:columns-5", children: Array.from(regionsGroupByLetter.entries()).map(renderRegionGroup(handleChangeLocation, branches?.dataSelect)) })), renderForeignOffices(foreignOffices)] }));
});
const regionFirstLetter = (region) => region.name?.charAt(0) || '';
const cleanUpRegions = (regions) => regions.map((region) => ({
    ...region,
    name: region.name?.replace(/республика|область|край'/gi, '').trim() || '',
}));
//# sourceMappingURL=LocationDialog.js.map